import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/Pagination/Pagination-Style2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/video/components/Loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoItem"] */ "/app/src/app/video/components/VideoItem.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/video/styles/page.module.css");
